import React from 'react'
import { TTableColumn, TTableRowProps } from '../../types/TableView';


const TableHeader = ({ columns, row}: TTableRowProps) => {
   
    return (
      
        <>
        {columns.map((col: TTableColumn, index: number) => {
            let className = "min-w-125px " + col.className;
            
            
            if (col.name === "image" && row.brand === "Hyper") {
                
                
                // Check if hyperImageUrl exists 
                if (row.hyperImageUrl && Array.isArray(row.hyperImageUrl) && row.hyperImageUrl.length > 0) {
                    return (
                        <td key={index} className={className + " text-center"}>
                            <img 
                                src={row.hyperImageUrl[0]} 
                                alt="Hyper" 
                                style={{ maxWidth: '45%', height: 'auto' }} 
                                onError={(e) => {
                                    console.error("Image failed to load:", row.hyperImageUrl[0]);
                                    e.currentTarget.style.display = 'none';
                                }}
                            />
                        </td>
                    );
                } 
            }
            if (col.name === "id") {
                className = col.className + " text-center";
            }
            
            return <td key={index} className={col.name === "name" ? className + " text-start" : className + " text-center"}>
                {col.renderCell && typeof col.renderCell === "function" ? col.renderCell(row) : row[col.name]}
            </td>
        })}
    </>
    )
}

export default TableHeader